import StepperContent from './styles';

export default StepperContent;
